export interface GlobalParams {
  title: string;
  copyright: string;
  supportEmail: string;
}

export const getGlobalParams = (): GlobalParams => ({
  title: "omnidata.mdm",
  copyright: "© 2021 omnidata.mdm",
  supportEmail: "support@omnidata.ru",
});
